module.exports = __webpack_public_path__ + "img/xp-tb-bingo-bash.b679abc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-bingo-bash.png
// module id = z4fE
// module chunks = 38 43